<template>
  <section v-if="variants.v1 === variant" class="layout-pt-lg layout-pb-lg">
    <BlockSymbol
      v-if="vars.blockPositionText"
      :position-text="String(vars?.blockPositionText || '')"
      :block-color="String(vars?.blockColor || '')"
      :block-symbol="String(vars?.blockSymbolText || '')"
      :block-opacity="Number(vars?.blockOpacityNumber || 1)"
      :image-class="`tw-max-w-full lg:tw-max-w-[45%]`"
      :block-logo-image="String(vars?.blockLogoImage)"
    />
    <div class="tw-absolute tw-inset-0" :style="`background-color: var(--c-${vars.backgroundColor})`"></div>
    <div class="container tw-z-10 tw-flex tw-flex-col tw-items-center tw-text-center">
      <div v-html="vars.titleHtml" class="tw-mb-9" :style="{ color: `var(--c-${vars.textColor})` }"></div>
      <div v-if="descriptions" class="tw-space-y-1">
        <p
          v-for="({ description }, index) in descriptions"
          :key="`takeaction-description-${index}`"
          class="mb-3 tw-max-w-2xl"
          :style="`${vars.textColor ? `color: var(--c-${vars.textColor}) !important` : ''}`"
        >
          {{ description }}
        </p>
      </div>
      <div v-if="buttons" class="tw-m-6 tw-flex tw-flex-wrap tw-justify-center tw-gap-2">
        <nuxt-link
          v-for="(button, index) in buttons"
          :key="`takeaction-button-${index}`"
          :to="button.link"
          :target="button.link.startsWith('http') ? '_blank' : '_self'"
          :class="`n-${button.type} tw-w-full md:tw-w-auto`"
          :external="true"
          >{{ button.label }}</nuxt-link
        >
      </div>
    </div>
  </section>

  <section
    v-if="variants.v2 === variant"
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="container">
      <div class="row y-gap-30 justify-between items-center">
        <div :style="`color: var(--c-${vars.textColor}) !important`" class="col-auto">
          <div v-html="vars.titleHtml"></div>
        </div>

        <div class="col-auto" v-for="(card, index) in cards" :key="index">
          <nuxt-link
            :to="String(card.button_link || '#')"
            :external="true"
            :class="`n-${card.button_type} tw-w-full tw-justify-start`"
          >
            {{ card.button_label }}
          </nuxt-link>
        </div>
      </div>
    </div>
  </section>

  <section
    v-if="variants.v3 === variant"
    class="layout-pt-lg layout-pb-lg"
    :style="`
    background-image: url('${
      isMobileDevice ? vars.mobileBackgroundImage || vars.backgroundImage : vars.backgroundImage
    }');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  `"
  >
    <div
      class="tw-absolute tw-inset-0 tw-opacity-80"
      :style="`background-color: var(--c-${vars.backgroundColor})`"
    ></div>
    <div class="container tw-z-10 tw-flex tw-flex-col tw-items-center tw-text-center">
      <h2
        v-if="vars.titleText && !vars.titleHtml"
        class="tw-max-w-3xl tw-pb-8 !tw-text-white"
        :color="`var(--c-${vars.textColor}) !important`"
      >
        {{ vars.titleText }}
      </h2>
      <div v-if="vars.titleHtml" class="tw-max-w-3xl tw-pb-8" v-html="vars.titleHtml" />
      <div v-if="descriptions" class="tw-space-y-1">
        <p
          v-for="({ description }, index) in descriptions"
          :key="`takeaction-description-${index}`"
          class="tw-max-w-2xl !tw-text-white"
        >
          {{ description }}
        </p>
      </div>
      <div v-if="buttons" class="tw-mt-10 tw-flex tw-justify-center tw-gap-6">
        <nuxt-link
          v-for="(button, index) in buttons"
          :key="`takeaction-button-${index}`"
          :to="button.link"
          :class="`n-${button.type} md:tw-w-auto`"
          :external="true"
        >
          {{ button.label }}
        </nuxt-link>
      </div>
    </div>
  </section>

  <section
    v-if="variants.v4 === variant"
    class="layout-pt-lg layout-pb-lg tw-relative"
    :style="`
    background-image: url('${
      isMobileDevice ? vars.mobileBackgroundImage || vars.backgroundImage : vars.backgroundImage
    }');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  `"
  >
    <video
      v-if="vars.backgroundVideoUrl"
      :src="String(isMobileDevice ? vars.mobileBackgroundVideoUrl || vars.backgroundVideoUrl : vars.backgroundVideoUrl)"
      autoplay
      loop
      muted
      playsinline
      class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-cover"
    ></video>
    <div v-if="vars.backgroundVideoUrl" class="tw-absolute tw-inset-0 tw-bg-black tw-opacity-40"></div>
    <div
      class="tw-absolute tw-inset-0 tw-opacity-80"
      :style="`background-color: var(--c-${vars.backgroundColor})`"
    ></div>
    <div class="container tw-z-10 tw-flex tw-flex-col tw-items-center tw-text-center">
      <h2 v-if="vars.titleText" class="tw-max-w-3xl tw-pb-8 !tw-text-white">
        {{ vars.titleText }}
      </h2>
      <div
        v-if="vars.titleHtml"
        class="tw-pb-8"
        :style="{ color: `var(--c-${vars.textColor})` }"
        v-html="vars.titleHtml"
      />
      <div v-if="descriptions" class="tw-space-y-1">
        <p
          v-for="({ description }, index) in descriptions"
          :key="`takeaction-description-${index}`"
          class="tw-max-w-2xl !tw-text-white"
        >
          {{ description }}
        </p>
      </div>
      <div v-if="buttons" class="tw-mt-10 tw-flex tw-justify-center tw-gap-6">
        <nuxt-link
          v-for="(button, index) in buttons"
          :key="`takeaction-button-${index}`"
          :to="button.link"
          :class="`n-${button.type} md:tw-w-auto`"
          :external="true"
        >
          {{ button.label }}
        </nuxt-link>
      </div>
    </div>
  </section>
  <section v-if="variants.v5 === variant" class="layout-pt-lg layout-pb-lg">
    <div class="tw-absolute tw-inset-0" :style="`background-color: var(--c-${vars.backgroundColor})`"></div>
    <div class="container tw-z-10 tw-flex tw-flex-col tw-items-center tw-text-center">
      <div v-html="vars.titleHtml" class="tw-mb-9" :style="{ color: `var(--c-${vars.textColor})` }"></div>
      <div v-if="descriptions" class="tw-space-y-1">
        <p
          v-for="({ description }, index) in descriptions"
          :key="`takeaction-description-${index}`"
          class="mb-3 tw-max-w-2xl"
          :style="`${vars.textColor ? `color: var(--c-${vars.textColor}) !important` : ''}`"
        >
          {{ description }}
        </p>
      </div>
      <div v-if="buttons" class="tw-m-6 tw-flex tw-flex-wrap tw-justify-center tw-gap-2">
        <nuxt-link
          v-for="(button, index) in buttons"
          :key="`takeaction-button-${index}`"
          :to="button.link"
          :target="button.link.startsWith('http') ? '_blank' : '_self'"
          :class="`n-${button.type} tw-w-full md:tw-w-auto`"
          :external="true"
          >{{ button.label }}</nuxt-link
        >
      </div>
    </div>
  </section>
  <section
    v-if="variants.v6 === variant"
    class="layout-pt-lg layout-pb-lg"
    :style="`
    background-image: url('${
      isMobileDevice ? vars.mobileBackgroundImage || vars.backgroundImage : vars.backgroundImage
    }');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  `"
  >
    <!-- Overlay -->
    <div
      class="tw-absolute tw-inset-0"
      :style="`
      background-color: var(--c-${vars.overlayColor || vars.backgroundColor});
      opacity: ${vars.overlayOpacityNumber};
    `"
    ></div>

    <div class="container tw-relative tw-z-10 tw-flex tw-flex-col tw-items-center tw-text-center">
      <h2 class="tw-max-w-3xl tw-pb-8 !tw-text-white">
        {{ vars.titleText }}
      </h2>
      <div v-if="descriptions" class="tw-space-y-1">
        <p
          v-for="({ description }, index) in descriptions"
          :key="`takeaction-description-${index}`"
          class="tw-max-w-2xl !tw-text-white"
        >
          {{ description }}
        </p>
      </div>
      <div v-if="buttons" class="tw-mt-10 tw-flex tw-justify-center tw-gap-6">
        <nuxt-link
          v-for="(button, index) in buttons"
          :key="`takeaction-button-${index}`"
          :to="button.link"
          :class="`n-${button.type} md:tw-w-auto`"
          :external="true"
        >
          {{ button.label }}
        </nuxt-link>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import BlockSymbol from '~/components/common/BlockSymbol.vue';

export default defineNuxtComponent({
  name: 'TakeAction',

  components: {
    BlockSymbol,
  },

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
        v4: 'v4',
        v5: 'v5',
        v6: 'v6',
      },
    };
  },

  computed: {
    descriptions(): Array<{ description: string }> {
      // @ts-ignore - groupedVariables is provided by ComponentMixin
      return this.groupedVariables?.descriptions || [];
    },
    buttons(): Array<{ link: string; type: string; label: string }> {
      // @ts-ignore - groupedVariables is provided by ComponentMixin
      return this.groupedVariables?.buttons || [];
    },
    cards() {
      return this.groupedVariables.cards;
    },
  },
});
</script>

<style scoped>
.block {
  font-size: 32em !important;
  font-weight: 900 !important;
  color: var(--c-secondary);
  line-height: 0.8;
  z-index: 1;
  margin: 0;
  padding: 0;
  position: absolute;
}
</style>
